module.exports = __webpack_public_path__ + "img/login-bg.f4fa7fe9.png";